import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { usePopup } from 'core/modules/Popup/PopupProvider';
import { useGetBonusOffers } from 'core/modules/BonusOffers/hooks';
import { useCheckIsEligibleToFetchData } from './useCheckIsEligibleToFetchData';
import { parseBonusButton } from 'core/modules/BonusButton/utils/parseBonusButton';
import { useIsButtonInstalled } from 'core/hooks/useIsButtonInstalled';

export const useHandleBonusButtonPopup = () => {
  const { openPopup } = usePopup();
  const isButtonInstalled = useIsButtonInstalled();
  const isEligibleToFetchData = useCheckIsEligibleToFetchData();
  const { bonusButtonPopup } = useGetBonusOffers(isEligibleToFetchData);

  useEffect(() => {
    const { isQualified, leftAmount, isEnded } = parseBonusButton(bonusButtonPopup);
    // pre-install (not qualified and without button) popup vs.
    // post-install (qualified but spend is less than threshold) popup
    const isQulifiedActionValid = !isQualified && !isButtonInstalled || isQualified && leftAmount > 0;

    if (isEligibleToFetchData && !isEmpty(bonusButtonPopup) && isQulifiedActionValid && !isEnded) {
      openPopup({
        name: 'popup_bonusButton',
        params: {
          isQualified,
        },
      });
    }
  }, [bonusButtonPopup, isEligibleToFetchData, isButtonInstalled]);
};
